import { lazy } from 'react';

export const Details = lazy(() => import('./Details.component'));
